import { useState } from 'react';

import Modal from "./UI/Modal";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFilter, faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";

import classes from "./StocksFilterForm.module.css"

const StocksFilterForm = (props) => {
    const [ticker, setTicker] = useState(props.filters.codigo ? props.filters.codigo.value : "");
    const [sector, setSector] = useState(props.filters.setor ? props.filters.setor.value : "");
    const [subSector, setSubSector] = useState(props.filters.subsetor ? props.filters.subsetor.value : "");

    const [mL, setML] = useState(props.filters.mL ? props.filters.mL.value : 0);
    const [mLOperator, setMLOperator] = useState(props.filters.mL ? props.filters.mL.operator : 0);
    const [disableML, setDisableML] = useState(props.filters.mL ? props.filters.mL.operator === 0 : true);

    const [divida, setDivida] = useState(props.filters.dlpl ? props.filters.dlpl.value : 0);
    const [dividaOperator, setDividaOperator] = useState(props.filters.dlpl ? props.filters.dlpl.operator : 0);
    const [disableDivida, setDisableDivida] = useState(props.filters.dlpl ? props.filters.dlpl.operator === 0 : true);

    const [pvp, setPvp] = useState(props.filters.pvp ? props.filters.pvp.value : 0);
    const [pvpOperator, setPvpOperator] = useState(props.filters.pvp ? props.filters.pvp.operator : 0);
    const [disablePvp, setDisablePvp] = useState(props.filters.pvp ? props.filters.pvp.operator === 0 : true);

    const [dy, setDy] = useState(props.filters.dy ? props.filters.dy.value : 0);
    const [dyOperator, setDyOperator] = useState(props.filters.dy ? props.filters.dy.operator : 0);
    const [disableDY, setDisableDy] = useState(props.filters.dy ? props.filters.dy.operator === 0 : true);

    const [vD, setVD] = useState(props.filters.vD ? props.filters.vD.value : 0);
    const [vDOperator, setVDOperator] = useState(props.filters.vD ? props.filters.vD.operator : 0);
    const [disableVD, setDisableVD] = useState(props.filters.vD ? props.filters.vD.operator === 0 : true);


    const [vM, setVM] = useState(props.filters.vM ? props.filters.vM.value : 0);
    const [vMOperator, setVMOperator] = useState(props.filters.vM ? props.filters.vM.operator : 0);
    const [disableVM, setDisableVM] = useState(props.filters.vM ? props.filters.vM.operator === 0 : true);

    const [vY, setVY] = useState(props.filters.vY ? props.filters.vY.value : 0);
    const [vYOperator, setVYOperator] = useState(props.filters.vY ? props.filters.vY.operator : 0);
    const [disableVY, setDisableVY] = useState(props.filters.vY ? props.filters.vY.operator === 0 : true);

    const [price, setPrice] = useState(props.filters.price ? props.filters.price.value : 0);
    const [priceOperator, setPriceOperator] = useState(props.filters.price ? props.filters.price.operator : 0);
    const [disablePrice, setDisablePrice] = useState(props.filters.price ? props.filters.price.operator === 0 : true);

    const changeTickerHandler = (value) => {
        setTicker(value);
    };

    const changeSectorHandler = (value) => {
        setSector(value);
    };

    const changeSubSectorHandler = (value) => {
        setSubSector(value);
    };

    const changeMargemHandler = (value) => {
        setML(value);
    };
    const changeMargemOperatorHandler = (value) => {
        if (value !== "") {
            setMLOperator(value);
            setDisableML(false);
        } else {
            setDisableML(true);
        }
    };

    const changeDividaHandler = (value) => {
        setDivida(value);
    };
    const changeDividaOperatorHandler = (value) => {
        if (value !== "") {
            setDividaOperator(value);
            setDisableDivida(false);
        } else {
            setDisableDivida(true);
        }
    };

    const changePvpHandler = (value) => {
        setPvp(value);
    };
    const changePvpOperatorHandler = (value) => {
        if (value !== "") {
            setPvpOperator(value);
            setDisablePvp(false);
        } else {
            setDisablePvp(true);
        }
    };

    const changeDividendYieldHandler = (value) => {
        setDy(value);
    };

    const changeDividendYieldOperatorHandler = (value) => {
        if (value !== "") {
            setDyOperator(value);
            setDisableDy(false);
        } else {
            setDisableDy(true);
        }
    };

    const changeVDHandler = (value) => {
        setVD(value);
    };
    const changeVDOperatorHandler = (value) => {
        if (value !== "") {
            setVDOperator(value);
            setDisableVD(false);
        } else {
            setDisableVD(true);
        }
    };


    const changeVMHandler = (value) => {
        setVM(value);
    };
    const changeVMOperatorHandler = (value) => {
        if (value !== "") {
            setVMOperator(value);
            setDisableVM(false);
        } else {
            setDisableVM(true);
        }
    };

    const changeVYHandler = (value) => {
        setVY(value);
    };
    const changeVYOperatorHandler = (value) => {
        if (value !== "") {
            setVYOperator(value);
            setDisableVY(false);
        } else {
            setDisableVY(true);
        }
    };

    const changePriceHandler = (value) => {
        setPrice(value);
    };
    const changePriceOperatorHandler = (value) => {
        if (value !== "") {
            setPriceOperator(value);
            setDisablePrice(false);
        } else {
            setDisablePrice(true);
        }
    };

    const filter = () => {
        const filters = {};
        if (ticker !== "") filters['codigo'] = { value: ticker };
        if (sector !== "") filters['setor'] = { value: sector };
        if (subSector !== "") filters['subsetor'] = { value: subSector };
        if (mLOperator !== 0) filters['mL'] = { value: mL, operator: mLOperator };
        if (dividaOperator !== 0) filters['dlpl'] = { value: divida, operator: dividaOperator };
        if (pvpOperator !== 0) filters['pvp'] = { value: pvp, operator: pvpOperator };
        if (dyOperator !== 0) filters['dy'] = { value: dy, operator: dyOperator };
        if (vDOperator !== 0) filters['vD'] = { value: vD, operator: vDOperator };
        if (vMOperator !== 0) filters['vM'] = { value: vM, operator: vMOperator };
        if (vYOperator !== 0) filters['vY'] = { value: vY, operator: vYOperator };
        if (priceOperator !== 0) filters['price'] = { value: price, operator: priceOperator };
        props.updateFilters(filters);
    };

    const clearFilters = () => {
        const filters = {};
        props.updateFilters(filters);
    };

    const closeFilterForm = () => {
        props.closeFilterForm();
    };

    return (
        <Modal modalClass={classes.modal} onClose={props.onClose}>
            <Form className='borderSpace'>
                <Container>
                    <Row>
                        <Col xs={12} className='minSpace text-center bg-success text-white'>FILTRAR STOCKS</Col>
                    </Row>
                    <Row>
                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Ticker:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={ticker}
                                    onChange={(e) => changeTickerHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Setor:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={sector}
                                    onChange={(e) => changeSectorHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={4} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='mb-1 assetFilterFormLabel'>Segmento:</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={subSector}
                                    onChange={(e) => changeSubSectorHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Margem:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={mLOperator}
                                    onChange={(e) => changeMargemOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={mL}
                                    disabled={disableML}
                                    onChange={(e) => changeMargemHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dívida Líquida/PL:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dividaOperator}
                                    onChange={(e) => changeDividaOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={divida}
                                    disabled={disableDivida}
                                    onChange={(e) => changeDividaHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>P/VP:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={pvpOperator}
                                    onChange={(e) => changePvpOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={pvp}
                                    disabled={disablePvp}
                                    onChange={(e) => changePvpHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Dividend Yield (12 meses):</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={dyOperator}
                                    onChange={(e) => changeDividendYieldOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={dy}
                                    disabled={disableDY}
                                    onChange={(e) => changeDividendYieldHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Dia:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vDOperator}
                                    onChange={(e) => changeVDOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vD}
                                    disabled={disableVD}
                                    onChange={(e) => changeVDHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Mês:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vMOperator}
                                    onChange={(e) => changeVMOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vM}
                                    disabled={disableVM}
                                    onChange={(e) => changeVMHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Variação 1 Ano:</small></Form.Label>
                                <Form.Select as="select" aria-label="Default select example"
                                    value={vYOperator}
                                    onChange={(e) => changeVYOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={vY}
                                    disabled={disableVY}
                                    onChange={(e) => changeVYHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='minSpace'>
                            <Form.Group>
                                <Form.Label className='minSpace'><small className='assetFilterFormLabel'>Preço:</small></Form.Label>
                                <Form.Select as="select" className={classes.filterFormControl}
                                    value={priceOperator}
                                    onChange={(e) => changePriceOperatorHandler(e.target.value)}
                                >
                                    <option value={undefined}>&nbsp;Nenhuma opção</option>
                                    <option value={"<"}>{'<'}&nbsp;&nbsp;&nbsp;Menor que</option>
                                    <option value={"<="}>{'<='}&nbsp;&nbsp;Menor ou igual que</option>
                                    <option value={"="}>{'='}&nbsp;&nbsp;&nbsp;Igual a</option>
                                    <option value={">"}>{'>'}&nbsp;&nbsp;&nbsp;Maior que</option>
                                    <option value={">="}>{'>='}&nbsp;&nbsp;Maior ou igual que</option>
                                </Form.Select>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={price}
                                    disabled={disablePrice}
                                    onChange={(e) => changePriceHandler(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="pt-1">
                        <Col xs={5} className='minSpace'>
                            <Form.Group>
                                <Button variant="primary" className="filterFormButton" onClick={filter}>
                                    <FontAwesomeIcon icon={faFilter} />&nbsp;Filtrar
                                </Button>
                            </Form.Group>
                        </Col>

                        <Col xs={5} className='minSpace'>
                            <Form.Group>
                                <Button variant="primary" className="filterFormButton" onClick={clearFilters}>
                                    <FontAwesomeIcon icon={faFilterCircleXmark} />&nbsp;Limpar
                                </Button>
                            </Form.Group>
                        </Col>

                        <Col xs={2} className='minSpace'>
                            <Button variant="warning" className="filterFormButton" onClick={closeFilterForm}>
                                <FontAwesomeIcon icon={faClose} />&nbsp;Fechar
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form >
        </Modal >
    );
};

export default StocksFilterForm;